"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _background = _interopRequireDefault(require("./background.js"));

var _icon = _interopRequireDefault(require("./icon.js"));

var _mask = _interopRequireDefault(require("./mask.js"));

var _networks = require("./networks.js");

var _styles = require("./styles.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function getNetworkKey(props) {
  return props.network || (0, _networks.keyFor)(props.url);
}

function SocialIcon(props) {
  var url = props.url,
      network = props.network,
      bgColor = props.bgColor,
      fgColor = props.fgColor,
      className = props.className,
      label = props.label,
      rest = _objectWithoutProperties(props, ["url", "network", "bgColor", "fgColor", "className", "label"]);

  var networkKey = getNetworkKey({
    url: url,
    network: network
  });
  return _react.default.createElement("a", _extends({}, rest, {
    href: url,
    className: 'social-icon' + (!!className ? ' ' + className : ''),
    style: _objectSpread({}, _styles.socialIcon, props.style),
    "aria-label": label || networkKey
  }), _react.default.createElement("div", {
    className: "social-container",
    style: _styles.socialContainer
  }, _react.default.createElement("svg", {
    className: "social-svg",
    style: _styles.socialSvg,
    viewBox: "0 0 64 64"
  }, _react.default.createElement(_background.default, null), _react.default.createElement(_icon.default, {
    networkKey: networkKey,
    fgColor: fgColor
  }), _react.default.createElement(_mask.default, {
    networkKey: networkKey,
    bgColor: bgColor
  }))));
}

SocialIcon.propTypes = {
  className: _propTypes.default.string,
  bgColor: _propTypes.default.string,
  label: _propTypes.default.string,
  network: _propTypes.default.string,
  url: _propTypes.default.string
};
var _default = SocialIcon;
exports.default = _default;